(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-certificate-query-certificate-query-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-f2-certificate-query-certificate-query-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-certificate-query-certificate-query-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-f2-certificate-query-certificate-query-domain'.");
    }
    root['boislocal-platform-platform-f2-certificate-query-certificate-query-domain'] = factory(typeof this['boislocal-platform-platform-f2-certificate-query-certificate-query-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-f2-certificate-query-certificate-query-domain'], this['kotlin-kotlin-stdlib'], this['fixers-f2-f2-dsl-f2-dsl-cqrs']);
  }
}(this, function (_, kotlin_kotlin, kotlin_io_komune_f2_f2_dsl_cqrs) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.fa;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var defineProp = kotlin_kotlin.$_$.b9;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var VOID = kotlin_kotlin.$_$.g;
  var PageQueryDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.a;
  var PageQueryResultDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(OuvrageCertificateDTO, 'OuvrageCertificateDTO', interfaceMeta);
  setMetadataFor(RealizationCertificateDTO, 'RealizationCertificateDTO', interfaceMeta);
  setMetadataFor(OuvrageCertificateRefDTO, 'OuvrageCertificateRefDTO', interfaceMeta);
  setMetadataFor(CertificatePolicies, 'CertificatePolicies', objectMeta);
  setMetadataFor(OuvrageCertificateGetQueryDTO, 'OuvrageCertificateGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(OuvrageCertificateGetResultDTO, 'OuvrageCertificateGetResultDTO', interfaceMeta);
  setMetadataFor(RealizationCertificateGetQueryDTO, 'RealizationCertificateGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(RealizationCertificateGetResultDTO, 'RealizationCertificateGetResultDTO', interfaceMeta);
  setMetadataFor(RealizationCertificatePageFiltersDTO, 'RealizationCertificatePageFiltersDTO', interfaceMeta);
  setMetadataFor(RealizationCertificatePageQueryDTO, 'RealizationCertificatePageQueryDTO', interfaceMeta, VOID, [PageQueryDTO]);
  setMetadataFor(RealizationCertificatePageResultDTO, 'RealizationCertificatePageResultDTO', interfaceMeta, VOID, [PageQueryResultDTO]);
  //endregion
  function OuvrageCertificateDTO() {
  }
  function RealizationCertificateDTO() {
  }
  function OuvrageCertificateRefDTO() {
  }
  function CertificatePolicies() {
  }
  protoOf(CertificatePolicies).canGetOuvrageCertificate = function () {
    return true;
  };
  protoOf(CertificatePolicies).canGetRealizationCertificate = function () {
    return true;
  };
  protoOf(CertificatePolicies).canPageRealizationCertificate = function () {
    return true;
  };
  var CertificatePolicies_instance;
  function CertificatePolicies_getInstance() {
    return CertificatePolicies_instance;
  }
  function OuvrageCertificateGetQueryDTO() {
  }
  function OuvrageCertificateGetResultDTO() {
  }
  function RealizationCertificateGetQueryDTO() {
  }
  function RealizationCertificateGetResultDTO() {
  }
  function RealizationCertificatePageFiltersDTO() {
  }
  function RealizationCertificatePageQueryDTO() {
  }
  function RealizationCertificatePageResultDTO() {
  }
  //region block: init
  CertificatePolicies_instance = new CertificatePolicies();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$certificate = $org$boislocal$platform$f2.certificate || ($org$boislocal$platform$f2.certificate = {});
    var $org$boislocal$platform$f2$certificate$query = $org$boislocal$platform$f2$certificate.query || ($org$boislocal$platform$f2$certificate.query = {});
    var $org$boislocal$platform$f2$certificate$query$domain = $org$boislocal$platform$f2$certificate$query.domain || ($org$boislocal$platform$f2$certificate$query.domain = {});
    var $org$boislocal$platform$f2$certificate$query$domain$model = $org$boislocal$platform$f2$certificate$query$domain.model || ($org$boislocal$platform$f2$certificate$query$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$certificate = $org$boislocal$platform$f2.certificate || ($org$boislocal$platform$f2.certificate = {});
    var $org$boislocal$platform$f2$certificate$query = $org$boislocal$platform$f2$certificate.query || ($org$boislocal$platform$f2$certificate.query = {});
    var $org$boislocal$platform$f2$certificate$query$domain = $org$boislocal$platform$f2$certificate$query.domain || ($org$boislocal$platform$f2$certificate$query.domain = {});
    var $org$boislocal$platform$f2$certificate$query$domain$model = $org$boislocal$platform$f2$certificate$query$domain.model || ($org$boislocal$platform$f2$certificate$query$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$certificate = $org$boislocal$platform$f2.certificate || ($org$boislocal$platform$f2.certificate = {});
    var $org$boislocal$platform$f2$certificate$query = $org$boislocal$platform$f2$certificate.query || ($org$boislocal$platform$f2$certificate.query = {});
    var $org$boislocal$platform$f2$certificate$query$domain = $org$boislocal$platform$f2$certificate$query.domain || ($org$boislocal$platform$f2$certificate$query.domain = {});
    var $org$boislocal$platform$f2$certificate$query$domain$policy = $org$boislocal$platform$f2$certificate$query$domain.policy || ($org$boislocal$platform$f2$certificate$query$domain.policy = {});
    defineProp($org$boislocal$platform$f2$certificate$query$domain$policy, 'CertificatePolicies', CertificatePolicies_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$certificate = $org$boislocal$platform$f2.certificate || ($org$boislocal$platform$f2.certificate = {});
    var $org$boislocal$platform$f2$certificate$query = $org$boislocal$platform$f2$certificate.query || ($org$boislocal$platform$f2$certificate.query = {});
    var $org$boislocal$platform$f2$certificate$query$domain = $org$boislocal$platform$f2$certificate$query.domain || ($org$boislocal$platform$f2$certificate$query.domain = {});
    var $org$boislocal$platform$f2$certificate$query$domain$query = $org$boislocal$platform$f2$certificate$query$domain.query || ($org$boislocal$platform$f2$certificate$query$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$certificate = $org$boislocal$platform$f2.certificate || ($org$boislocal$platform$f2.certificate = {});
    var $org$boislocal$platform$f2$certificate$query = $org$boislocal$platform$f2$certificate.query || ($org$boislocal$platform$f2$certificate.query = {});
    var $org$boislocal$platform$f2$certificate$query$domain = $org$boislocal$platform$f2$certificate$query.domain || ($org$boislocal$platform$f2$certificate$query.domain = {});
    var $org$boislocal$platform$f2$certificate$query$domain$query = $org$boislocal$platform$f2$certificate$query$domain.query || ($org$boislocal$platform$f2$certificate$query$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$certificate = $org$boislocal$platform$f2.certificate || ($org$boislocal$platform$f2.certificate = {});
    var $org$boislocal$platform$f2$certificate$query = $org$boislocal$platform$f2$certificate.query || ($org$boislocal$platform$f2$certificate.query = {});
    var $org$boislocal$platform$f2$certificate$query$domain = $org$boislocal$platform$f2$certificate$query.domain || ($org$boislocal$platform$f2$certificate$query.domain = {});
    var $org$boislocal$platform$f2$certificate$query$domain$query = $org$boislocal$platform$f2$certificate$query$domain.query || ($org$boislocal$platform$f2$certificate$query$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-f2-certificate-query-certificate-query-domain.js.map
